import { NativeSelect } from '@odekoteam/doppio';

import { GThirdPartyVehicleType } from 'src/graphql/types/generated';
import {
  ANY_VEHICLE_LABEL,
  VEHICLE_TYPES,
  VehicleChoice,
  vehicleLabel,
} from 'src/utils/thirdPartyDelivery';

// The select's value for "any vehicle": a native select holds strings only.
const ANY = 'ANY';

const ITEMS = [
  ...VEHICLE_TYPES.map((vehicle) => ({
    value: vehicle as string,
    label: vehicleLabel(vehicle),
  })),
  { value: ANY, label: `${ANY_VEHICLE_LABEL} (may be a car)` },
];

type VehicleFieldProps = {
  // Unique per dialog view: the mark form and Change are separate views.
  id: string;
  // Undefined while the warehouse's default is unknown: nothing is chosen
  // yet, and the dialog does not send until the GM picks.
  value: VehicleChoice | undefined;
  isDisabled?: boolean;
  onChange: (vehicle: VehicleChoice) => void;
};

// The vehicle class the provider quotes for. Burq quotes every class when the
// request names none, and the cheapest is usually a car.
export function VehicleField({
  id,
  value,
  isDisabled = false,
  onChange,
}: VehicleFieldProps): JSX.Element {
  let selected = '';
  if (value !== undefined) selected = value ?? ANY;
  return (
    <>
      <label
        htmlFor={id}
        sx={{ variant: 'text.paragraphMdDefault', fontWeight: 'bold' }}
      >
        Vehicle
      </label>
      <NativeSelect
        id={id}
        items={ITEMS}
        value={selected}
        placeholder={
          value === undefined
            ? { value: '', label: 'Choose a vehicle' }
            : undefined
        }
        isDisabled={isDisabled}
        onValueChange={(next): void =>
          onChange(next === ANY ? null : (next as GThirdPartyVehicleType))
        }
      />
    </>
  );
}
